export class Split {
    falls: boolean | null = null;
    obstacleId: string | null = null;
    obstacleNumber: number | null = null;
    runId: string | null = null;
    submitterId: string | null = null;
    timeSpent: number | null = null;
    createdAt: Date | null = null;
}
